'use client';

/* eslint-disable no-console */
import { useContext, createContext, type ReactNode } from 'react';

export interface IMarkdownContextStateProps {
  codeBlock?: {
    wrapLongLines?: boolean;
  };
}

interface IMarkdownProviderProps extends IMarkdownContextStateProps {
  children: ReactNode;
}

const MarkdownContext = createContext<IMarkdownContextStateProps>({});

export function MarkdownProvider({
  children,
  ...rest
}: IMarkdownProviderProps) {
  return (
    <MarkdownContext.Provider
      value={{
        ...rest,
      }}
    >
      {children}
    </MarkdownContext.Provider>
  );
}

export function useMarkdownContext(): IMarkdownContextStateProps {
  const markdownContext = useContext(MarkdownContext);

  if (!markdownContext) {
    console.log('useMarkdownContext must be used inside MarkdownProvider');
  }

  return markdownContext;
}
